<template>
    <a-col :span="24" slot="content">
      <a-row v-for="(item, index) in list" :key="index">
        <ads-item v-if="item" :item="item" :index="index" @qrcode="qrcode"/>
      </a-row>
    </a-col>
</template>

<script>
import AdsItem from '@/com/Ads/AdsItem.vue'

export default {
  name: 'AdsList',
  props: {
    list: {
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      relitem: {}
    }
  },
  components: {
    AdsItem
  },
  filters: {
  },
  methods: {
    qrcode: function(id, url) {
      this.$emit('qrcode', id, url);
    }
  }
}
</script>

<style scoped>
</style>
